import { useEffect, useMemo, useState } from 'react';
import CancleAdd from '../../components/CancleAdd/CancleAdd';
import Title from '../../components/Title/Title';
import { useNavigate, useParams } from 'react-router-dom';
import {  notifySuccess } from '../../utils/utils';
import { useFieldArray, useForm, } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ToastContainer } from 'react-toastify';
import InputLabel from '../../components/InputLabel/InputLabel';
import requestHttp from '../../http/requestHttp/requestHttp';
import { EditRequestTemplateDefaultValue } from './EditRequestTemplateDefaultValue';

import 'react-toastify/dist/ReactToastify.css';
import RequestErrorEditRequestTemplate from './RequestErrorEditRequestTemplate';
import CurrencyInputNew from '../../components/CurrencyInputNew/CurrencyInputNew';
import Line from '../../components/Line/Line';
import Service from '../../http/seviceHttp/seviceHttp';
import MultiSelect from '../../components/MultiSelect/MultiSelect';

export default function EditRequestTemplate() {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [allServicesData, setAllServicesData] = useState([]);
  const [data, setData] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    control,
    reset,
  } = useForm({
    defaultValues: useMemo(() => EditRequestTemplateDefaultValue(), []),
    resolver: yupResolver(RequestErrorEditRequestTemplate()),
  });
  const navigate = useNavigate();

  const afterSubmit = () => {
    notifySuccess('Request Template successfully changed');
    setTimeout(() => {
      navigate('/Admin/RequestForms');
    }, 2000);
  };

  const onSubmit = async data => {
    const SendData = {
      activities:
        data.activities?.length >= 1
          ? data?.activities?.map(elem => {
              return {
                id: elem?.id,
                hours: elem?.hours,
                activity: elem?.activity,
              };
            })
          : [],
      service_ids: data?.service_ids,
      name: data?.name,
    };

    setIsLoading(true);
    requestHttp
      ?.editRequestTemplates(SendData,params?.id)
      .then(() => afterSubmit())
      .catch(err => {
        const errorFromBackend = Object.keys(err?.response?.data?.errors);
        errorFromBackend.forEach(item =>
          setError(item, { type: 'custom', message: err?.response?.data?.errors?.[item] }),
        );
        setIsLoading(false);
      });
  };

  const onClickCancel = () => {
    navigate('/Admin/RequestFroms');
  };

  const {
    fields: ActivitiesFields,
    append: ActivitiesAppend,
    remove: ActivitiesRemove,
  } = useFieldArray({
    control,
    name: `activities`,
  });

  const onClickAddNewActivities = () => {
    ActivitiesAppend({});
  };

  useEffect(() => {
    reset(EditRequestTemplateDefaultValue(data));
    Service.serviceLinksWithoutPagination().then(e => {
      const uniqueIdsSet = new Set();
      const serviceList = e?.data?.data
        ?.map(item => ({
          value: item?.id || item?.[0]?.employee_id,
          label: item?.name || item?.[0]?.name,
        }))
        .reduce((result, item) => {
          if (!uniqueIdsSet.has(item.value)) {
            uniqueIdsSet.add(item.value);
            result.push(item);
          }

          return result;
        }, []);
      serviceList.unshift({ value: 'All', label: 'All Services' });
      setAllServicesData(serviceList);
    });
  }, [data]);

  useEffect(() => {
    params?.id &&
      requestHttp.getRequestTemplateById(params?.id).then(e => {
        setData(e?.data?.data);
        // setState(e?.data?.data?.file.uuid)
      });
  }, []);

  return (
    <div className="sm:px-8 px-2 py-8 w-full ">
      <div className="w-full bg-white rounded-md">
        <div className="py-4 sm:px-7 px-2 w-full">
          <Title title={'Edit Template'} className="border-b py-1" classNameTitle={'text-2xl font-semibold'} />
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <div className="w-full bg-white p-4 rounded-md">
            <div className="grid md:grid-cols-2 sm:gap-6 gap-2 items-end">
              <div className="mt-5">
                <InputLabel
                  classNameInput="flex flex-col"
                  classNameLabel={'text-[#60657B] text-xs font-normal p-1 opacity-50'}
                  className="w-full border p-[7px]"
                  labelTitle={'Template Title'}
                  placeholder={'Template Title'}
                  register={register}
                  name={`name`}
                />
                {errors && <p className="mb-0 text-sm text-amber-800">{errors?.name?.message}</p>}
              </div>
              <div className="w-full bg-white">
                <MultiSelect
                  title={'Services'}
                  selectData={allServicesData}
                  selectClass="flex-col gap-2"
                  name={'service_ids'}
                  All="All Services"
                  className="w-full box-content focus:outline-none h-[40px] border rounded cursor-pointer h-full"
                  classNameTitle="text-[#60657B] opacity-50 text-xs"
                  setValue={setValue}
                  defalutValue={data?.services?.map(elem => {
                    return { value: elem?.id, label: elem?.name };
                  })}
                />
                {errors && <p className="mb-0 text-sm text-amber-800">{errors?.service_ids?.message}</p>}
              </div>
            </div>
            <div id="currencyUseFieldArray" className="w-full mt-5">
              <Line />
              <p className="text-xl font-bold my-2">Administrator overwrite of Activity Logs</p>
              {ActivitiesFields.map((item, activitiesindex) => {
                return (
                  <div key={item?.id} className={`${activitiesindex !== 0 && 'mt-2'}`}>
                    <div className="grid md:grid-cols-2 md:gap-6 gap-2">
                      <div className="">
                        <CurrencyInputNew
                          classNameLabel="text-[#60657B]  text-xs font-normal p-1 opacity-50"
                          className={'w-full border p-[7px] outline-none rounded border p-1'}
                          name={`activities.${activitiesindex}.hours`}
                          setValue={setValue}
                          placeholder="0.00"
                          defaultValue={data?.activities?.[activitiesindex]?.hours}
                          prefix=""
                          labelTitle={'Hours'}
                        />
                        {errors && (
                          <p className="mb-0 text-sm text-amber-800">
                            {errors?.activities?.[activitiesindex]?.hours?.message}
                          </p>
                        )}
                      </div>
                      <div className="flex flex-col w-full">
                        <div className="flex w-full">
                          <InputLabel
                            labelTitle={'Activity'}
                            className="border-b-[0.5px] box-border px-4 py-2 w-full outline-0 outline-none placeholder-[#7F8182]"
                            classNameInput="w-full"
                            placeholder={'Activity'}
                            name={`activities.${activitiesindex}.activity`}
                            register={register}
                            classNameLabel={'text-[#60657B] opacity-50 text-xs font-normal'}
                            required={{ required: 'This field is required' }}
                          />
                          {activitiesindex >= 1 && (
                            <button
                              type="button"
                              className="w-8 h-[40px] mt-6 box-border rounded border border-[#E4E6F2] text-[#60657B]"
                              onClick={() => ActivitiesRemove(activitiesindex)}>
                              X
                            </button>
                          )}
                        </div>
                        {errors && (
                          <p className="mb-0 text-sm text-amber-800">
                            {errors?.activities?.[activitiesindex]?.activity?.message}
                          </p>
                        )}
                      </div>
                    </div>
                    {activitiesindex === ActivitiesFields?.length - 1 && (
                      <section>
                        <button
                          className="text-[#2B2D38] opacity-50 text-base"
                          type="button"
                          onClick={onClickAddNewActivities}>
                          + Add Activities
                        </button>
                      </section>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="mt-40 z-50">
            <CancleAdd disabled={isLoading} buttonText={`Update`} onClickCancel={onClickCancel} />
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}
